import { render, staticRenderFns } from "./Benutzer.vue?vue&type=template&id=69235ea2"
import script from "./Benutzer.vue?vue&type=script&lang=js"
export * from "./Benutzer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports